'use strict';
import Push from 'push.js';

//signalrService MIGRADO
angular.module('TurneroApp').component('coAtencionListadoSidebar', {
    bindings: {
        centroAtencionSeleccionado: '<',
        turnos: '<',
        cargandoGrilla: '<',
        usuarioConfig: '<',
        bloquearAcciones: '<',
        ctrlPadre: '='
    },
    controller: [
        'TurneroAppConstant',
        '$state',
        '$location',
        '$scope',
        '$localStorage',
        function (TurneroAppConstant, $state, $location, $scope, $localStorage) {
            var ctrl = this;
            // se definen las constantes que estan en TurneroAppConstant como variables locales para poder utilizarlas en el js y el html
            ctrl.TurnosEstados = TurneroAppConstant.Estados.Turno;
            ctrl.Modalidades = TurneroAppConstant.Modalidades;
            ctrl.Prioridades = TurneroAppConstant.Prioridades;
            ctrl.Derivacion = TurneroAppConstant.Derivacion;
            ctrl.$onInit = function () {
                //INICIALIZACION DEL COMPONENTE
                if (!ctrl.centroAtencionSeleccionado.id) {
                    $state.go('pantallaAtencionSidebar');
                }
            };

            ctrl.$onChanges = function () {
                ctrl.Turnos = ctrl.turnos;
            }

            ctrl.tiempoEsperaReferencia = function () {
                //Este metodo muestra el popup con la explicacion de los circulos de colores al lado del tiempo de espera
                var htmltext = '<div class="text-left"><span class="text-success"><i class="fa fa-circle-o"></i></span> = La persona se anunció antes del horario de su turno.<br/><span class="text-success"><i class="fa fa-circle"></i></span> = La persona se anunció a horario y está esperando atención.<br/><span class="text-warning"><i class="fa fa-circle"></i></span> = La persona ha esperado por al menos la duración de un turno.<br/><span class="text-danger"><i class="fa fa-circle"></i></span> = La persona ha esperado por al menos la duración de dos turnos.</div>'
                swal({
                    title: 'Espera - Referencia de color',
                    html: htmltext,
                    type: 'info',
                    confirmButtonColor: '#004b81',
                    confirmButtonText: "Aceptar",
                    allowEscapeKey: false,
                    allowOutsideClick: false
                })
            }

            //Atender button
            ctrl.onAtenderTurno = function (turno) {
                // Llamar a atenderTurno del padre para cambiar el estado del turno
                if (ctrl.ctrlPadre && ctrl.ctrlPadre.atenderTurno) {
                    ctrl.ctrlPadre.atenderTurno(turno);
                }
            };

            //Perder button
            ctrl.onPerderTurno = function (turno) {
                ctrl.ctrlPadre.perderTurno(turno);
            };

            ctrl.validarBotonPerder = function (turno) {
                if (turno.Id_Estado == ctrl.TurnosEstados.Llamado &&
                    turno.Cant_Llamados >= 2 &&
                    turno.Id_Centro_Usuario == $localStorage.TurneroApp_UsuarioSesion.Id_Centro_Usuario)
                    return false;

                return true;
            }

            //Llamar button
            ctrl.onLlamarTurno = function (turno) {
                ctrl.ctrlPadre.llamarTurno(turno, true);
            };

            ctrl.validarBotonLlamar = function (turno) {
                //validaciones para saber si bloquear o no el boton llamar
                if (ctrl.usuarioConfig && ctrl.usuarioConfig.Llamador_Activo != undefined && ctrl.usuarioConfig.Solo_Llamar_Proximo != undefined) {
                    //Retorno true cuando el boton debe estar deshabilitado sino retorno false
                    if (turno.Id_Estado == ctrl.TurnosEstados.Atendido ||
                        !ctrl.usuarioConfig.Llamador_Activo ||
                        (ctrl.usuarioConfig.Solo_Llamar_Proximo && turno.Id_Estado != ctrl.TurnosEstados.Retenido) ||
                        (turno.Id_Estado == ctrl.TurnosEstados.Derivado && !ctrl.derivadoAMi) ||
                        ((turno.Id_Estado == ctrl.TurnosEstados.Llamado || turno.Id_Estado == ctrl.TurnosEstados.Retenido) &&
                           turno.Id_Centro_Usuario != ctrl.usuarioConfig.Id_Centro_Usuario)) {
                        //bloqueo el boton llamar
                        return true;
                    } else
                        //No lo bloqueo.
                        return false;
                }
                //bloqueo el boton llamar
                return true;
            }
        }],
    template: require('./sidebarAtencionListado.html')
});



// WEBPACK FOOTER //
// ./app/components/atencion/sidebarAtencionListadoComponent.js